import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getAccount } from '../utils/api';

// Async thunk for fetching user data
export const fetchUserData = createAsyncThunk(
  'user/fetchUserData',
  async (accessToken, { rejectWithValue }) => {
    try {
      const response = await getAccount(accessToken);
      // Laravel /account returns a UserResource wrapped as { data: {...} } — no
      // `success` flag. Accept either envelope so the account widget populates.
      const payload = response?.data?.data ?? response?.data;
      if (payload && (payload.email || payload.first_name || payload.id)) {
        return payload;
      }
      return rejectWithValue('Failed to fetch user data');
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'An error occurred');
    }
  }
);

const userSlice = createSlice({
  name: 'user',
  initialState: {
    userData: null,
    status: 'idle', // 'idle' | 'loading' | 'succeeded' | 'failed'
    error: null
  },
  reducers: {
    updateUserData: (state, action) => {
      state.userData = {
        ...state.userData,
        ...action.payload,
      };
      state.status = 'succeeded';
    },
    clearUserData: (state) => {
      state.userData = null;
      state.status = 'idle';
    },
    setAvatarLoading: (state, action) => {
      if (state.userData) {
        state.userData.avatarLoading = action.payload;
      }
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchUserData.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchUserData.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.userData = {
          ...action.payload,
          avatarLoading: false // Always clear loading state when new data arrives
        };
        state.error = null;
      })
      .addCase(fetchUserData.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload;
        if (state.userData) {
          state.userData.avatarLoading = false; // Clear loading state on error
        }
      });
  }
});

export const { updateUserData, clearUserData, setAvatarLoading } = userSlice.actions;
export default userSlice.reducer; 